import { useState } from "react";
import { IPartnerTenantDetailsChartProps } from "../../interfaces/PartnerView.interfaces";
import { CustomCardWithCharts } from "../../SharedComponents/CustomCardWithCharts";
import { ChartDataOption } from "../../SharedComponents/Interfaces/CustomCardWithCharts.interfaces";
import { groupBy } from "../../Utils/js-common";
import { CUSTOMER_VIEW_STYLES } from "../CustomerView/CustomerView.styles";

export default function PartnerTenantDetailsChart(props: IPartnerTenantDetailsChartProps) {
  // Properties
  const [metricFilters, setMetricFilters] = useState<{ [key: string]: any }>({});

  // Events
  const handleResetFilters = () => {
    setMetricFilters({});
    props.onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  };
  /**
   * onClick action for each datapoint in the chart
   */
  const handleDataPointClick = (option: ChartDataOption<any>) => {
    const { field, title, value } = option;

    props.onSelectedChartFilter({
      filterKey: field,
      value: value
    });
    setMetricFilters((prev) => ({ ...prev, [title]: value }));
  };

  // Events
  const getGroupedCountData = (key: string, data: any[]) => {
    const filteredData = data.filter((item) => item[key]);
    const groupedData = groupBy(filteredData, key);

    return Object.keys(groupedData)?.map((item) => ({
      name: item,
      value: groupedData[item].length
    }));
  };

  const getPartnerAssociationTypeCountData = (key: string, data: any[]) => {
    let cspCount = 0;
    let cporCount = 0;
    let palCount = 0;

    data.forEach((item) => {
      const assocType = (item[key] || "").toLowerCase();
      if (assocType.includes("csp")) cspCount++;
      if (assocType.includes("cpor")) cporCount++;
      if (assocType.includes("pal")) palCount++;
    });
    return [
      { name: "CSP", value: cspCount },
      { name: "CPOR", value: cporCount },
      { name: "PAL", value: palCount }
    ];
  };

  const partnerAssociationTypeDistribution = getPartnerAssociationTypeCountData(
    "partnerAssociationType",
    props.filteredData
  );
  const segmentDistribution = getGroupedCountData("segmentGroup", props.filteredData);
  const industryDistribution = getGroupedCountData("industryName", props.filteredData);

  return (
    <>
      <div className={CUSTOMER_VIEW_STYLES.COMMON_STYLES.CLASS_NAMES.customCardContainer}>
        <CustomCardWithCharts
          enableUrlParams
          loading={props.loading}
          metricFilters={metricFilters}
          onDataPointClick={handleDataPointClick}
          onResetFilters={handleResetFilters}
          options={{
            chartOptions: [
              {
                id: 1,
                field: "partnerAssociationType",
                key: "partner-view-tenant-details-chart-by-partnerAssociationType",
                title: "Tenant's by Partner Association",
                tooltipDescription: "Distribution of tenants by their partner associations (CSP, CPOR, PAL).",
                type: "verticalbar",
                kustoLink: props.associationTypeKustoLink,
                groupedData:partnerAssociationTypeDistribution
              },
              {
                id: 2,
                field: "segmentGroup",
                key: "partner-view-partner-profile-chart-by-segmentGroup",
                title: "Partner's Tenant Customer Segment Group Distribution",
                tooltipDescription: "Distribution of partners by their tenant customer segment groups.",
                type: "donut",
                kustoLink: props.segementDistributionKustoLink,
                groupedData: segmentDistribution
              },
              {
                id: 3,
                field: "industryName",
                key: "partner-view-partner-profile-chart-by-industryName",
                title: "Partner's Tenant Industry Distribution",
                tooltipDescription: "Distribution of partners by their tenant industries.",
                type: "donut",
                kustoLink: props.industryKustoLink,
                groupedData: industryDistribution
              }
            ]
          }}
        />
      </div>
    </>
  );
}
